(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.isProductPage = true;
      this.nomadSlides = Array.from(this.querySelectorAll('.nomad-gallery__slide'));
      this.nomadIndex = 0;
      this.nomadCounter = this.querySelector('[data-nomad-gallery-index]');
      this.nomadStage = this.querySelector('.nomad-gallery__content');
      this.nomadTouchStartX = null;

      this.querySelectorAll('[data-nomad-gallery-nav]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const movement = button.dataset.nomadGalleryNav === 'next' ? 1 : -1;
          this.nomadShowIndex(this.nomadIndex + movement);
        });
      });

      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.nomadShowIndex(this.nomadIndex + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.nomadShowIndex(this.nomadIndex - 1);
        }
      });

      if (this.nomadStage) {
        this.nomadStage.addEventListener('touchstart', (event) => {
          if (event.changedTouches.length) {
            this.nomadTouchStartX = event.changedTouches[0].screenX;
          }
        }, { passive: true });

        this.nomadStage.addEventListener('touchend', (event) => {
          if (this.nomadTouchStartX === null || !event.changedTouches.length) return;
          const delta = event.changedTouches[0].screenX - this.nomadTouchStartX;
          this.nomadTouchStartX = null;
          if (Math.abs(delta) > 45) {
            this.nomadShowIndex(this.nomadIndex + (delta < 0 ? 1 : -1));
          }
        }, { passive: true });
      }
    }

    show(opener) {
      super.show(opener);
      const mediaId = opener ? opener.getAttribute('data-media-id') : null;
      const selected = this.nomadSlides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      this.nomadShowIndex(selected >= 0 ? selected : 0);
    }

    nomadShowIndex(nextIndex) {
      const total = this.nomadSlides.length;
      if (!total) return;
      this.nomadIndex = ((nextIndex % total) + total) % total;
      this.nomadSlides.forEach((slide, index) => {
        const current = index === this.nomadIndex;
        slide.classList.toggle('active', current);
        slide.setAttribute('aria-hidden', current ? 'false' : 'true');
        if (current) {
          const image = slide.querySelector('img');
          if (image) image.loading = 'eager';
        }
      });
      if (this.nomadCounter) this.nomadCounter.textContent = String(this.nomadIndex + 1);
    }

    hide() {
      this.nomadTouchStartX = null;
      super.hide(this.isProductPage);
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();
})();
